import React from 'react'
import { useWeb3React } from '@web3-react/core'
import SVG from 'react-inlinesvg'
import cancelIcon from 'assets/cancel.svg'
import styled from 'styled-components'
import Button from '../../Button'
import { ButtonAppearanceEnum } from '../../Button/types'
import useModal from '../../../hooks/useModal'
import ConnectModal from '../../ConnectModal'
import useAuth from '../../../hooks/useAuth'
import truncate from '../../../utils/truncate'

const Account = styled.div`
  background-color: #DCE5FF;  
  display: flex;
  align-items: center;
  height: 60px;
  width: 345px;
  max-width: calc(100% - 30px);
  font-size: 12px;
  font-weight: 700;
  border-radius: 10px;
  justify-content: center;
  color: #252525;

  :hover {
    opacity: ${({ theme }) => theme.opacity};
    cursor: pointer;
  }
`

const Address = styled.span`
  padding: 0 !important;
`



const WalletButtonMobileMenu = () => {
  const { openModal } = useModal()
  const { account } = useWeb3React()
  const { login, logout } = useAuth()

  return account ? (
    <Account onClick={logout}>
      <Address>{truncate(account)}</Address>
    </Account>
  ) : (
      <Button onClick={() => openModal({children: ConnectModal, props: { login },})}
        appearance={ButtonAppearanceEnum.primary}
        style={{width: 345, maxWidth: "calc(100% - 30px)", height: 60}}
      >
        <p> Connect Wallet </p>
      </Button>
  )
}

export default WalletButtonMobileMenu
